'use client';
import { useCallback, useContext } from 'react';
import { usePathname } from 'next/navigation';
import { SessionContext } from '@benzinga/session-context';
import { TrackingManager } from '@benzinga/tracking-manager';
import { deriveQuoteActiveTabFromPathname } from './active-tab';

/**
 * Returns a stable callback that fires a Segment `page_event` / `click` for an
 * interactive control on a quote sub-page. `section` identifies the control
 * (e.g. 'financials_period_toggle'); the active tab is derived from the path.
 */
export const useQuoteTrackClick = () => {
  const session = useContext(SessionContext);
  const pathname = usePathname();

  return useCallback(
    (section: string) => {
      session.getManager(TrackingManager).trackPageEvent('click', {
        page_section: section,
        page_tab: deriveQuoteActiveTabFromPathname(pathname),
      });
    },
    [session, pathname],
  );
};
